// Generated by Claude Code
import { useEffect } from 'react'

/**
 * Hard browser navigation to `/login` — not an SPA `<Navigate>` — because the login page is
 * served by v1 on the same origin and must be fetched fresh. `location.replace` keeps the
 * expired page out of history.
 */
export function LoginRedirect({ redirect }: { redirect?: string }) {
  useEffect(() => {
    const target = redirect ? `/login?redirect=${encodeURIComponent(redirect)}` : '/login'
    window.location.replace(target)
  }, [redirect])
  return null
}
